import { Controller } from "@hotwired/stimulus"
import { Calendar } from "@fullcalendar/core"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"

export default class extends Controller {
  static values = { url: String }
  static targets = [ "map", "stateFilter", "responsibleFilter" ]
  connect() {
    const mapTarget = this.hasMapTarget ? this.mapTarget : this.element
    this.calendar = new Calendar(mapTarget, {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: "dayGridWeek",
      locale: "ru",
      firstDay: 1,
      height: "auto",
      weekends: false,
      headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,dayGridWeek"
      },
      buttonText: {
        today: "Сегодня",
        month: "Месяц",
        week: "Неделя"
      },
      eventTextColor: '#333333',
      events: this.urlValue,
      eventClassNames: 'p-0 overflow-hidden rounded-md border-0 shadow-sm',
      eventContent: function(arg) {
        const themeTitle = arg.event.title
        const responsible = arg.event.extendedProps.responsible
        const author = arg.event.extendedProps.author
        const state = arg.event.extendedProps.state

        const checkIcon = `
          <svg xmlns="http://w3.org" viewBox="0 0 20 20" fill="currentColor" class="w-3.5 h-3.5 shrink-0">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />
          </svg>
        `

        const statusIcon = state === 'completed' || arg.event.extendedProps.state === 'closed' ?  checkIcon : ''
        const html = `
          <div class="flex flex-col p-1.5 min-w-0 text-sm leading-tight">
            <div class="flex items-center gap-1 font-semibold truncate">
              <span>${statusIcon}</span>
              <span class="truncate">${themeTitle}</span>
            </div>
            
            <div class="mt-1 text-xs">
              <div class="truncate flex items-center gap-0.5">
                <span class="shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-3">
                    <path d="m5.433 13.917 1.262-3.155A4 4 0 0 1 7.58 9.42l6.92-6.918a2.121 2.121 0 0 1 3 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 0 1-.65-.65Z" />
                    <path d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0 0 10 3H4.75A2.75 2.75 0 0 0 2 5.75v9.5A2.75 2.75 0 0 0 4.75 18h9.5A2.75 2.75 0 0 0 17 15.25V10a.75.75 0 0 0-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5Z" />
                  </svg>
                </span>
                <span class="truncate italic">${author}</span>
              </div>
              
              <div class="mt-0.5 truncate flex items-center gap-0.5">
                <span class="shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-3">
                    <path d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z" />
                  </svg>
                </span>
                <span class="truncate italic">${responsible}</span>
              </div>
            </div>
          </div>
        `
        return { html: html }
      },

      eventClick: this.handleEventClick.bind(this),
      dateClick: this.handleDateClick.bind(this)
    })

    this.calendar.render();
    mapTarget.M_FullCalendar = this.calendar
  }

  applyFilters() {
    const state = this.hasStateFilterTarget ? this.stateFilterTarget.value : ""
    const responsibleIds = this.hasResponsibleFilterTarget ? Array.from(this.responsibleFilterTarget.selectedOptions).map(option => option.value).filter(Boolean) : ""
    const authorIds = this.hasAuthorFilterTarget ? Array.from(this.authorFilterTarget.selectedOptions).map(option => option.value).filter(Boolean) : ""

    const url = new URL(this.urlValue, window.location.origin)
    if (state) url.searchParams.append("type", state)
    if (responsibleIds.length > 0) {
      responsibleIds.forEach(id => url.searchParams.append("responsible[]", id))
    }
    if (authorIds.length > 0) {
      authorIds.forEach(id => url.searchParams.append("author[]", id))
    }

    const currentSources = this.calendar.getEventSources()
    currentSources.forEach(source => source.remove())

    this.calendar.addEventSource(url.toString())
  }

  disconnect() {
    if (this.calendar) this.calendar.destroy()
  }

  resize() {
    requestAnimationFrame(() => {
      this.calendar.updateSize()
    })
  }

  handleEventClick(info) {
    window.open(`/missions/${info.event.id}/info`, '_blank', 'noopener,noreferrer')
  }

  handleDateClick(info) {
    window.open(`/missions/new?deadline=${info.dateStr}`, '_blank', 'noopener,noreferrer')
  }
}
